import { Injectable } from "@angular/core";
import { IndustryDiscountPageableResult } from "src/app/ui/models/domains/pbm/industry/industry-discount-pageable-result.model";
import { AbstractParser } from "../../parser";
import { parseIndustryDiscounts } from "./industry-discount-functions";

@Injectable()
export class IndustryDiscountsPageableResultParser extends AbstractParser<IndustryDiscountPageableResult> {
  parse(payload: any): IndustryDiscountPageableResult {
    const industryDiscountPageableResult = new IndustryDiscountPageableResult();
    industryDiscountPageableResult.setStart(payload.Start);
    industryDiscountPageableResult.setTotal(payload.TotalPerPages);
    industryDiscountPageableResult.setTotalPerPages(payload.Total);
    industryDiscountPageableResult.setData(parseIndustryDiscounts(payload.Data));

    return industryDiscountPageableResult;
  }
}
